<template>
  <div class="campaigns registration">
    <div class="inner-content">
      <v-form @submit="register">
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              filled
              name="first_name"
              label="Име"
              type="text"
              v-validate="'required'"
              v-model="user.first_name"
              :error-messages="errors.collect('first_name')"
              @keyup.enter="updateProfile"
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field
              filled
              name="last_name"
              label="Фамилия"
              type="text"
              v-validate="'required'"
              v-model="user.last_name"
              :error-messages="errors.collect('last_name')"
              @keyup.enter="updateProfile"
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field
              filled
              name="email"
              label="Електронна поща"
              type="text"
              v-validate="'required|email'"
              v-model="user.email"
              :error-messages="errors.collect('email')"
              @keyup.enter="updateProfile"
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field
              filled
              v-model="user.password"
              :append-icon="showPass ? 'visibility' : 'visibility_off'"
              :type="showPass ? 'text' : 'password'"
              name="password"
              v-validate="'required'"
              label="Парола"
              :error-messages="errors.collect('password')"
              counter
              @click:append="showPass = !showPass"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-checkbox
              v-model="user.agree"
              color="primary"
              v-validate='required'
              name="toc"
              :error-messages="errors.collect('toc')"
              label="Съгласен съм личните ми данни да се обработват с цел предоставяне на възможност за участие в кампании и получаване на известия"
              hide-details
            ></v-checkbox>
          </v-col>
        </v-row>

        <v-row class="mt-5">
          <v-col>
            <v-btn color="primary" :disabled="submitDisabled" class="mt-5 mb-5 mr-4" @click="register">Създай профил</v-btn>
          </v-col>
        </v-row>
      </v-form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Registration',

  data () {
    return {
      showPass: false,
      user: {
        first_name: '',
        last_name: '',
        email: '',
        password: '',
        agree: false
      }
    }
  },

  methods: {
    register () {
      this.$store.commit('setLoading', true)

      this.$store.dispatch('registerUser', this.user).then(() => {
        // success
        this.$store.commit('setLoading', false)
        this.$router.push('/регистрация/потвърди')
      }).catch(() => {
        this.$store.commit('setLoading', false)
        this.$store.commit('showError', 'Въведеният мейл вече е зает.')
        this.user.email = ''
      })
    },

    validateUpTo (fieldName) {
      for (let field of this.$validator.fields.items) {
        if (field.name === fieldName) {
          break
        }

        this.$validator.validate(field.name)
      }
    }
  },

  computed: {
    submitDisabled () {
      return this.user.first_name.length === 0 || this.user.last_name.length === 0 ||
        this.user.email.length === 0 || this.user.password.length === 0 ||
        this.errors.items.length > 0 || !this.user.agree
    }
  },

  watch: {
    'user.email': function (newValue) {
      this.user.email = newValue.replace(/ /g, '')
    }
  }
}
</script>
